/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Connect
 */
export interface Connect {
    /**
     * 
     * @type {string}
     * @memberof Connect
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Connect
     */
    address?: string;
}

export function ConnectFromJSON(json: any): Connect {
    return ConnectFromJSONTyped(json, false);
}

export function ConnectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Connect {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
    };
}

export function ConnectToJSON(value?: Connect | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'address': value.address,
    };
}

